import { Tabs } from '../../../components/Tabs';
import { Dispatch, SetStateAction } from 'react';
import { CalendarEvents } from './CalandarEvents';
import { CreateEventForm } from '../../../forms/CreateEventForm';
import { EventDetails } from '../../../interfaces/userInterfaces';

interface EventModalProps {
  useCase: string;
  eventDate: Date;
  eventList: EventDetails[];
  setSelectedDate: Dispatch<SetStateAction<Date | null>>;
}

export const CalendarEventModal: React.FC<EventModalProps> = ({
  eventDate,
  eventList,
  useCase,
  setSelectedDate,
}) => {
  const calendar = {
    tabs: ['View My Events', 'Create Event'],
    content: [
      <CalendarEvents dateOfEvent={eventDate} eventList={eventList} key="view-events" />,
      <CreateEventForm key="create-event-form" eventDate={eventDate} />,
    ],
    modal: true,
  };

  return (
    <div id="calendar-action-div" className="calendar-action-div">
      <button
        className="calendar-action-div-x"
        onClick={() => setSelectedDate(null)}
        aria-label="Close"
      >
        ✕
      </button>
      <p style={{ fontWeight: 500, marginBottom: '12px' }}>{eventDate.toDateString()}</p>
      {useCase === 'public' ? (
        <CalendarEvents dateOfEvent={eventDate} eventList={eventList} key="public-events" />
      ) : (
        <Tabs page={calendar} />
      )}
    </div>
  );
};
